import { ModalCollectionEditStoreInterface } from '@/store/ModalCollectionEditStore'
import { modalCollectionEditStore } from '@/utils/store-accessor'

export class ModalCollectionEditService {
  public open(params: ModalCollectionEditStoreInterface) {
    modalCollectionEditStore.open(params)
  }

  public close() {
    modalCollectionEditStore.close()
  }
}
